/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');
require('./bid/bid');

import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('live-bid', require('./components/LiveBidComponent.vue').default);
Vue.component('tenant-live-bid', require('./tenant/components/LiveBidComponent.vue').default);
Vue.component('live-auction', require('./components/LiveAuctionComponent.vue').default);
Vue.component('bid-prebid', require('./components/BidPrebidComponent.vue').default);
Vue.component('bid-online', require('./components/BidOnlineComponent.vue').default);
Vue.component('bid-online-tenant', require('./components/BidOnlineTenantComponent.vue').default);
Vue.component('bid-favorite', require('./components/BidFavoriteComponent.vue').default);
Vue.component('bid-private', require('./components/BidPrivateComponent.vue').default);
Vue.component('bargain', require('./components/BargainComponent.vue').default);
Vue.component('bargain-tenant', require('./components/BargainTenantComponent.vue').default);
Vue.component('bidding-member', require('./components/BiddingMemberComponent.vue').default);
Vue.component('bid-past-member', require('./components/BidPastMemberComponent.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
